<template>
  <select
    class="block w-full h-10 p-2 pr-8 placeholder-gray-400 bg-no-repeat border border-gray-300 rounded appearance-none cursor-pointer"
    :value="value"
    @change="$emit('change', $event.target.value)"
  >
    <slot></slot>
  </select>
</template>

<script>
export default {
  props: ["value"],
  model: {
    prop: "value",
    event: "change",
  },
};
</script>

<style scoped>
select {
  background-color: inherit;
  background-image: url("data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'%3E%3Cpath d='M2.454 5.303L.636 7.121 7 13.485l6.364-6.364-1.818-1.818L7 9.849 2.454 5.303z' fill='%23191919'/%3E%3C/svg%3E");
  background-size: 15px;
  background-position-y: center;
  background-position-x: calc(100% - 8px);
}
</style>
